import React from "react";
import { FaUserCheck, FaUserClock, FaTimesCircle, FaUserTie, FaExclamationCircle } from "react-icons/fa";

const StatusBadge = ({ status }) => {
  const statusConfig = {
    Nouveau: {
      color: "#9ca3af",
      text: "Nouveau",
      icon: <FaExclamationCircle  />,
    },
    Sélectionné: {
      color: "#2A76E6",
      text: "Sélectionné",
      icon: <FaUserCheck />,
    },
    "En Entretien": {
      color: "#FBA026",
      text: "En Entretien",
      icon: <FaUserClock />,
    },
    "En Attente": {
      color: "#FBA026",
      text: "En Attente",
      icon: <FaUserClock />,
    },
    Accepté: {
      color: "#22c55e",
      text: "Accepté",
      icon: <FaUserTie />,
    },
    Refusé: {
      color: "#f87171 ",
      text: "Refusé",
      icon: <FaTimesCircle />,
    },
    Recruté: {
      color: "#3D348B",
      text: "Recruté",
      icon: <FaUserTie />,
    },
  };

  const currentStatus = statusConfig[status] || {
    color: "#000000",
    text: "Inconnu",
    icon: null,
  };

  return (
    <div
      className="py-3 px-3 text-sm flex items-center gap-2 "
      style={{ color: currentStatus.color }}
    >
      {currentStatus.icon && (
        <span className="text-lg">{currentStatus.icon}</span>
      )}
      {currentStatus.text}
    </div>
  );
};

export default StatusBadge;
